import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { makeEnvironmentProviders } from '@angular/core';
import { ExponentialBackoffInterceptor } from '../interceptors/exponential-backoff.interceptor';

/**
 *
 * @param standaloneInterceptors use false in legacy applications importing `HttpClientModule`, true in standalone applications using `provideHttpClient(withInterceptors(backendVersionCheckInterceptor))`
 * @returns
 */
export const provideExponentialBackoff = (standaloneInterceptors = true) =>
    makeEnvironmentProviders([
        standaloneInterceptors
            ? ExponentialBackoffInterceptor
            : {
                  provide: HTTP_INTERCEPTORS,
                  useClass: ExponentialBackoffInterceptor,
                  multi: true,
              },
    ]);
